import { render, staticRenderFns } from "./parainput.vue?vue&type=template&id=3130e99d&scoped=true&"
import script from "./parainput.vue?vue&type=script&lang=js&"
export * from "./parainput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130e99d",
  null
  
)

export default component.exports